import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import SocialMetaTags from "./SocialMetaTags";
import { DEFAULT_OG_IMAGE, getCanonicalUrl, getSeoForPath } from "./seoConstants";

/**
 * Route-level Open Graph / Twitter defaults for every page.
 * Page-specific SocialMetaTags (e.g. resource detail) override these when rendered later.
 */
const RouteSocialMeta = () => {
  const { pathname } = useLocation();
  const seo = useMemo(() => getSeoForPath(pathname), [pathname]);
  const url = getCanonicalUrl(pathname);

  return (
    <SocialMetaTags
      title={seo.ogTitle}
      description={seo.description}
      twitterDescription={seo.twitterDescription}
      image={DEFAULT_OG_IMAGE}
      url={url}
    />
  );
};

export default RouteSocialMeta;
